import { Injectable } from "@angular/core";
import { PaymentsColumnName } from "@helper/types/payment";

@Injectable()
export class PaymentsColumnsService {
	private key = "dom.payments.columns";

	public save(columns: PaymentsColumnName[]): void {
		localStorage.setItem(this.key, columns.join("."));
	}

	public restore(): PaymentsColumnName[] {
		const str = localStorage.getItem(this.key) || null;
		return (
			str
				? str.split(".")
				: [
					"accountNumber",
					"bankCode",
					"paymentDocumentNumber",
					"paymentDocumentDate",
					"paymentDate",
					"paymentSum",
					"transferSum",
					"commissionSum",
					"refundAvailableSum",
					"refundSum",
					"fullName",
					"address",
					"description",
					"claimId",
					"paymentId",
					"providerOperId",
				]
		) as PaymentsColumnName[];
	}
}
